<template>
  <el-config-provider :locale="locale">
    <component :is="route.meta.auth ? MainLayout : AuthLayout" />
  </el-config-provider>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { ElConfigProvider } from 'element-plus'
import AuthLayout from '@/layout/AuthLayout.vue'
import MainLayout from '@/layout/MainLayout.vue'
import i18n from '@/lang/index.js'
import en from 'element-plus/dist/locale/en.min.js'
import de from 'element-plus/dist/locale/de.min.js'
import dayjs from 'dayjs'

const route = useRoute()
dayjs.Ls.en.weekStart = 1

const isLanguageSwitchAvailable = computed(() => {
  return import.meta.env.VITE_LANGUAGE_SWITCH_AVAILABLE
})

const locale = computed(() =>
  isLanguageSwitchAvailable.value && i18n.global.locale === 'en' ? en : de
)

onMounted(() => {
  if (isLanguageSwitchAvailable.value) {
    i18n.global.locale = localStorage.getItem('language') ?? 'de'
  }
})
</script>
